<template>
    <CicPopup
        :help-text="$t('DESC_ROUTE_PLAN_REVISIONS')"
        :title="$t('Route Plan') + ': ' + item.name"
        @blur="$emit('blur')"
    >
        <table id="plan_revisions" class="cic-table">
            <thead>
                <tr>
                    <th class="th-checkbox">{{ $t('Active') }}</th>
                    <th>{{ $t('Version') }}</th>
                    <th>{{ $t('Revision Date') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="revision in item.revisions">
                    <td class="td-checkbox">
                        <CicCheckbox
                            :enabled="item.revision !== revision.revisionId"
                            :value="item.revision === revision.revisionId"
                            @click="$emit('change', revision.revisionId)"
                        />
                    </td>
                    <td>{{ revision.revisionId }}</td>
                    <td>{{ revision.updated }}</td>
                </tr>
            </tbody>
        </table>
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicCheckbox from '@/components/inputs/CicCheckbox';

    export default {
        name: 'EditRevision',
        components: {
            CicCheckbox,
            CicPopup,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change'],
    };
</script>
